/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Юридическое лицо
 * @export
 * @interface LegalEntity
 */
export interface LegalEntity {
  /**
   *
   * @type {string}
   * @memberof LegalEntity
   */
  organizationType: LegalEntityOrganizationTypeEnum
  /**
   * ИНН заказчика
   * @type {string}
   * @memberof LegalEntity
   */
  inn: string
  /**
   * Наименование заказчика с указанием краткого формата ОПФ
   * @type {string}
   * @memberof LegalEntity
   */
  name: string
  /**
   * Адрес заказчика, с указанием индекса, города, улица и квартиры.
   * @type {string}
   * @memberof LegalEntity
   */
  address: string
  /**
   * Адрес для корреспонденции заказчика. Заказчик может указать адрес в произвольном формате
   * @type {string}
   * @memberof LegalEntity
   */
  addressCorrespondent?: string
  /**
   * совпадает ли addresss и addressCorrespondent
   * @type {boolean}
   * @memberof LegalEntity
   */
  addressEqual: boolean
}

/**
 * @export
 * @enum {string}
 */
export enum LegalEntityOrganizationTypeEnum {
  LegalEntity = 'LEGAL_ENTITY',
}

/**
 * Check if a given object implements the LegalEntity interface.
 */
export function instanceOfLegalEntity(value: object): value is LegalEntity {
  if (!('organizationType' in value) || value['organizationType'] === undefined)
    return false
  if (!('inn' in value) || value['inn'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('address' in value) || value['address'] === undefined) return false
  if (!('addressEqual' in value) || value['addressEqual'] === undefined)
    return false
  return true
}

export function LegalEntityFromJSON(json: any): LegalEntity {
  return LegalEntityFromJSONTyped(json, false)
}

export function LegalEntityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LegalEntity {
  if (json == null) {
    return json
  }
  return {
    organizationType: json['organizationType'],
    inn: json['inn'],
    name: json['name'],
    address: json['address'],
    addressCorrespondent:
      json['addressCorrespondent'] == null
        ? undefined
        : json['addressCorrespondent'],
    addressEqual: json['addressEqual'],
  }
}

export function LegalEntityToJSON(value?: LegalEntity | null): any {
  if (value == null) {
    return value
  }
  return {
    organizationType: value['organizationType'],
    inn: value['inn'],
    name: value['name'],
    address: value['address'],
    addressCorrespondent: value['addressCorrespondent'],
    addressEqual: value['addressEqual'],
  }
}
